export const leadsFilterCategoryMap = {
    signals: "signals",
    company: "company",
    website: "website",
    trafficAndEngagement: "trafficAndEngagement",
    advertiserActivity: "advertiserActivity",
    crm: "crm",
    exclude: "exclude",
} as const;

export type LeadsFilterCategory = (typeof leadsFilterCategoryMap)[keyof typeof leadsFilterCategoryMap];
